const organization = {
  getMyOrganizations: function() {
    const query =
      `
      {
        GetMyOrganizations(userId: ` +
      this.$store.getters.user.User_Id +
      `){
          Organization_Id
          Parent_Organization_Id
          Name
          Account{
            Account_Id
            Account_Name
            Account_Type{
              Account_Type_Id
              Title
            }
          }
          Organization_Type{
            Organization_Type_Id
            Title
          }
          Users{
            User_Id
            First_Name
            Last_Name
            Email
            Phone
          }
          Students(userId: ` +
      this.$store.getters.user.User_Id +
      `){
              Student_Id
              Name
              Grade{
                Grade_Id
                Title
              }
              Subjects(userId: ` +
      this.$store.getters.user.User_Id +
      `){
                Subject_Id
              }
              Units(userId: ` +
      this.$store.getters.user.User_Id +
      `){
                Unit_Id
              }
          }
          Subjects(userId: ` +
      this.$store.getters.user.User_Id +
      `){
            Subject_Id
            Title
            Description
            Organization_Id
            Units{
              Unit_Id
              Title
              Description
              Num_Scores
              Score_Template_Id
            }
          }
        }
      }
    `;
    return this.$store.getters
      .fetcher({ query })
      .then(res => res.data.GetMyOrganizations);
  },
  getMySubjectOrganizations: function() {
    const query =
      `
      {
        GetMyOrganizations(userId: ` +
      this.$store.getters.user.User_Id +
      `){
          Organization_Id
          Parent_Organization_Id
          Name
          Organization_Type_Id
          Subjects(userId: ` +
      this.$store.getters.user.User_Id +
      `){
            Subject_Id
            Title
            Description
            Organization_Id
            Units{
              Unit_Id
              Title
              Description
              Num_Scores
              Score_Template_Id
            }
          }
        }
      }
    `;
    return this.$store.getters
      .fetcher({ query })
      .then(res => res.data.GetMyOrganizations);
  },
  getMyArchivedSubjectOrganizations: function() {
    const query =
      `
      {
        GetMyOrganizations(userId: ` +
      this.$store.getters.user.User_Id +
      `){
          Organization_Id
          Parent_Organization_Id
          Name
          Organization_Type_Id
          Archived_Subjects(userId: ` +
      this.$store.getters.user.User_Id +
      `){
            Subject_Id
            Title
            Description
            Organization_Id
            Is_Archived
            Archived_Units{
              Unit_Id
              Title
              Description
              Is_Archived
              Score_Template_Id
              Num_Scores
            }
          }
        }
      }
    `;
    return this.$store.getters
      .fetcher({ query })
      .then(res => res.data.GetMyOrganizations);
  },
  getMySimpleOrganizations: function() {
    const query =
      `
      {
        GetMyOrganizations(userId: ` +
      this.$store.getters.user.User_Id +
      `){
          Organization_Id
          Parent_Organization_Id
          Organization_Type_Id
          Name
          Subjects(userId: ` +
      this.$store.getters.user.User_Id +
      `){
            Subject_Id
            Title
            Description
            Organization_Id
            Units{
              Unit_Id
              Subject_Id
              Title
              Description
            }
          }
          Users{
            User_Id
            First_Name
            Last_Name
          }
        }
      }
    `;
    return this.$store.getters
      .fetcher({ query })
      .then(res => res.data.GetMyOrganizations);
  },
  getPermissionOrganizations: function() {
    const query =
      `
      {
        GetMyOrganizations(userId: ` +
      this.$store.getters.user.User_Id +
      `){
          Organization_Id
          Parent_Organization_Id
          Organization_Type_Id
          Name
        }
      }
    `;
    return this.$store.getters
      .fetcher({ query })
      .then(res => res.data.GetMyOrganizations);
  },
  createOrganization: function(organizationToCreate) {
    const query = `
      mutation($name: String!, $accountId: Int!, $organizationTypeId: Int!, $parentOrganizationId: Int! ) {
        CreateOrganization(name: $name, accountId: $accountId, organizationTypeId: $organizationTypeId, parentOrganizationId: $parentOrganizationId ) {
          Organization_Id
        }
      }`;
    const variables = {
      name: organizationToCreate.Name,
      accountId: organizationToCreate.Account
        ? parseInt(organizationToCreate.Account.Account_Id)
        : parseInt(organizationToCreate.Account_Id),
      organizationTypeId: parseInt(
        organizationToCreate.Organization_Type.Organization_Type_Id
      ),
      parentOrganizationId: parseInt(
        organizationToCreate.Parent_Organization_Id
      )
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      organizationToCreate.Organization_Id =
        res.data.CreateOrganization.Organization_Id;
      return organizationToCreate;
    });
  },
  updateOrganization: function(organizationToUpdate) {
    const query = `
      mutation($organizationId: Int!, $name: String!, $accountId: Int!, $organizationTypeId: Int!, $parentOrganizationId: Int! ) {
        UpdateOrganization(organizationId: $organizationId, name: $name, accountId: $accountId, organizationTypeId: $organizationTypeId, parentOrganizationId: $parentOrganizationId ) {
          Organization_Id
        }
      }`;
    const variables = {
      organizationId: parseInt(organizationToUpdate.Organization_Id),
      name: organizationToUpdate.Name,
      accountId: parseInt(organizationToUpdate.Account_Id),
      organizationTypeId: parseInt(
        organizationToUpdate.Organization_Type.Organization_Type_Id
      ),
      parentOrganizationId: parseInt(
        organizationToUpdate.Parent_Organization_Id
      )
    };
    return this.$store.getters
      .fetcher({ query, variables })
      .then(() => organizationToUpdate);
  },

  createStudentOrganizations: async function(studentId, organizationIds) {
    const query = `
      mutation($studentId: Int!, $organizationIds: [Int]!) {
        CreateStudentOrganizations(studentId: $studentId, organizationIds: $organizationIds) {
          Student_Organization_Id
        }
      }`;
    const variables = {
      studentId: parseInt(studentId),
      organizationIds: organizationIds.map(o => parseInt(o))
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.CreateStudentOrganizations;
    });
  },

  removeStudentOrganizations: async function(studentId, organizationIds) {
    const query = `
      mutation($studentId: Int!, $organizationIds: [Int]!) {
        RemoveStudentOrganizations(studentId: $studentId, organizationIds: $organizationIds) 
      }`;
    const variables = {
      studentId: parseInt(studentId),
      organizationIds: organizationIds.map(o => parseInt(o))
    };
    return this.$store.getters.fetcher({ query, variables }).then(res => {
      return res.data.RemoveStudentOrganizations;
    });
  }
};

export { organization };
